import "../styles/Astrology.css";
import ZodiacSignContainer from "./ZodiacSignContainer";

function Astrology() {
  return (
    <>
      <h1 className="col">Daily horoscope</h1>
      <div className="container">
        <ZodiacSignContainer />
        <p>
          Image par{" "}
          <a
            href="https://pixabay.com/fr/users/darkmoon_art-1664300/?utm_source=link-attribution&amp;utm_medium=referral&amp;utm_campaign=image&amp;utm_content=4374408"
            target="_blank"
            rel="noreferrer"
          >
            Darkmoon_Art
          </a>{" "}
          de{" "}
          <a
            href="https://pixabay.com/fr/?utm_source=link-attribution&amp;utm_medium=referral&amp;utm_campaign=image&amp;utm_content=4374408"
            target="_blank"
            rel="noreferrer"
          >
            Pixabay
          </a>
        </p>
      </div>
    </>
  );
}

export default Astrology;
